import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Lightbulb } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import PadletEmbed from "@/components/teacher/inspiration/PadletEmbed";

interface IdeaSuggestionDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const CURIO_FEEDBACK_PADLET_URL =
  "https://padlet.com/scioresearch/n-vrhy-na-zlep-en-aplikace-curio-sp2v2mqvrmh6cgix";

const IdeaSuggestionDialog: React.FC<IdeaSuggestionDialogProps> = ({ open, onOpenChange }) => {
  const { t } = useLanguage();

  const padletTitle = t(
    "Návrhy na zlepšení aplikace Curio",
    "Návrhy na zlepšenie aplikácie Curio"
  );

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[900px] max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Lightbulb className="h-5 w-5 text-primary" />
            {t("Navrhnout nápad", "Navrhnúť nápad")}
          </DialogTitle>
          <DialogDescription>
            {t(
              "Podělte se s námi o svůj nápad na zlepšení aplikace Curio. Vaše návrhy můžete přidat na sdílenou nástěnku níže.",
              "Podeľte sa s nami o svoj nápad na zlepšenie aplikácie Curio. Vaše návrhy môžete pridať na zdieľanú nástenku nižšie."
            )}
          </DialogDescription>
        </DialogHeader>

        <PadletEmbed url={CURIO_FEEDBACK_PADLET_URL} title={padletTitle} />
      </DialogContent>
    </Dialog>
  );
};

export default IdeaSuggestionDialog;
